import { Visibility } from '@mui/icons-material';
import {
  Autocomplete,
  CircularProgress,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
} from '@mui/material';
import React, { ComponentType, useEffect, useState } from 'react';
import api from '../../services/api';
import { auth } from '../../services/auth';

export const ViewAs: ComponentType = () => {
  const [allUsers, setAllUsers] = useState<unknown[]>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api
      .get('/users', new URLSearchParams({ orderBy: 'name' }))
      .then(setAllUsers as any);
  }, []);

  return (
    <ListItem>
      <ListItemIcon
        sx={{
          minWidth: '36px',
        }}
      >
        <Visibility />
      </ListItemIcon>
      <ListItemText>
        <Autocomplete
          loading={allUsers === undefined}
          loadingText="Loading users..."
          onChange={(_, value: any) => {
            if (value !== null) {
              setLoading(true);
              api
                .post('/read-only-sessions', { userId: value.id })
                .then((session: any) => {
                  auth.setOverrideToken(session.id);
                  window.location.assign('/');
                })
                .finally(() => setLoading(false));
            }
          }}
          disabled={loading}
          popupIcon={loading ? <CircularProgress size={24} /> : undefined}
          getOptionKey={(option) => option.id}
          getOptionLabel={(option) => {
            let label = option.name;

            const details = [
              option.roles.map((role: any) => role.name).join(', '),
              option.service_providers.map((role: any) => role.name).join(', '),
            ]
              .filter((detail: string) => detail.length)
              .join(' - ');

            if (details.length) {
              label += ` (${details})`;
            }

            return label;
          }}
          renderInput={(params) => (
            <TextField {...params} label="View as" size="small" fullWidth />
          )}
          options={allUsers || []}
        />
      </ListItemText>
    </ListItem>
  );
};
